import { ecgProjectionAdapter, getECGProjectionSnapshot, } from './ecgProjectionAdapter.js';
export { createDefaultECGRenderPaths, createECGRenderPathResolver, } from './ECGRenderPathResolver.js';
export { DefaultECGDataProvider } from './DefaultECGDataProvider.js';
export const ecgProjection = {
    adapter: ecgProjectionAdapter,
    getSnapshot: getECGProjectionSnapshot,
};
export { default } from './ECGViewport.js';
